export default __webpack_public_path__ + "static/media/botanyIcon.ce9c6cfa.svg";